/* eslint-disable no-unused-vars */
import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { EmpTrainings } from '../../pages/ats-operator';
import { NotificationsCenter } from '../../pages/common';
import withAdminLayout from '../../layout/withAdminLayout';

const Dashboard = lazy(() => import('../../pages/ats-operator/dashboard'));
const NotFound = lazy(() => import('../../container/pages/404'));

const SuperAdmin = React.memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<Dashboard />} />
        <Route index path="/emp-trainings" element={<EmpTrainings />} />
        <Route index path="/notifications" element={<NotificationsCenter />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(SuperAdmin);
